import axios from 'axios';
import config from './config';

const API_URL = `${config.API_BASE_URL}/Notifications`;

// ════════════════════════════════════════════════════
// CRUD
// ════════════════════════════════════════════════════
export const fetchNotifications = async () => {
	try {
		const response = await axios.get(API_URL);
		return response.data;
	} catch (error) {
		console.error('Error fetching notifications:', error);
		throw error;
	}
};

export const fetchNotificationById = async (id) => {
	try {
		const response = await axios.get(`${API_URL}/${id}`);
		return response.data;
	} catch (error) {
		console.error('Error fetching notification:', error);
		throw error;
	}
};

export const createNotification = async (data) => {
	try {
		const response = await axios.post(API_URL, data);
		return response.data;
	} catch (error) {
		console.error('Error creating notification:', error);
		throw error;
	}
};

export const updateNotification = async (id, data) => {
	try {
		const response = await axios.put(`${API_URL}/${id}`, data);
		return response.data;
	} catch (error) {
		console.error('Error updating notification:', error);
		throw error;
	}
};

export const deleteNotification = async (id) => {
	try {
		const response = await axios.delete(`${API_URL}/${id}`);
		return response.data;
	} catch (error) {
		console.error('Error deleting notification:', error);
		throw error;
	}
};

export const fetchNotificationsByType = async (type) => {
	try {
		const response = await axios.get(`${API_URL}/type/${type}`);
		return response.data;
	} catch (error) {
		console.error('Error fetching notifications by type:', error);
		throw error;
	}
};

// ════════════════════════════════════════════════════
// ⚠️ LEGACY: Send to all (kept for backwards compatibility)
// ════════════════════════════════════════════════════
export const sendNotificationToAll = async (data) => {
	try {
		const response = await axios.post(`${API_URL}/send-to-all-users`, data);
		return response.data;
	} catch (error) {
		console.error('Error sending notification to all users:', error);
		throw error;
	}
};

export const sendNotificationToAllAdmins = async (data) => {
	try {
		const response = await axios.post(`${API_URL}/send-to-all-admins`, data);
		return response.data;
	} catch (error) {
		console.error('Error sending notification to all admins:', error);
		throw error;
	}
};

// ════════════════════════════════════════════════════
// Clone notification for user (order lifecycle)
// ════════════════════════════════════════════════════
export const cloneNotificationByTypeForUser = async (data) => {
	try {
		const response = await axios.post(`${API_URL}/clone-by-type-for-user`, data);
		return response.data;
	} catch (error) {
		console.error('Error cloning notification:', error);
		throw error;
	}
};

// ════════════════════════════════════════════════════
// Read state
// ════════════════════════════════════════════════════
export const markNotificationAsRead = async (id) => {
	try {
		const response = await axios.put(`${API_URL}/${id}/mark-read`);
		return response.data;
	} catch (error) {
		console.error('Error marking notification as read:', error);
		throw error;
	}
};

export const markAllNotificationsAsReadForUser = async (userId) => {
	try {
		const response = await axios.put(`${API_URL}/user/${userId}/mark-all-read`);
		return response.data;
	} catch (error) {
		console.error('Error marking all notifications as read:', error);
		throw error;
	}
};

export const getUnreadCount = async (userId) => {
	try {
		const response = await axios.get(`${API_URL}/user/${userId}/unread-count`);
		return response.data;
	} catch (error) {
		console.error('Error getting unread count:', error);
		throw error;
	}
};

export const fetchNotificationsByUser = async (userId, unreadOnly = false) => {
	try {
		const url = unreadOnly
			? `${API_URL}/user/${userId}?unread=true`
			: `${API_URL}/user/${userId}`;
		const response = await axios.get(url);
		return response.data;
	} catch (error) {
		console.error('Error fetching notifications by user:', error);
		throw error;
	}
};

// ════════════════════════════════════════════════════
// ✅ WHATSAPP ONLY senders (no DB save, no app push)
// ════════════════════════════════════════════════════

// Send WhatsApp to a single user
export const sendWhatsAppToUser = async (data) => {
	try {
		const response = await axios.post(`${API_URL}/whatsapp/user`, data);
		return response.data;
	} catch (error) {
		console.error('Error sending WhatsApp to user:', error);
		throw error;
	}
};

// Send WhatsApp to multiple/all users (omit userIds for ALL)
export const sendWhatsAppToUsers = async (data) => {
	try {
		const response = await axios.post(`${API_URL}/whatsapp/users`, data);
		return response.data;
	} catch (error) {
		console.error('Error sending WhatsApp to users:', error);
		throw error;
	}
};

// Send WhatsApp to a single admin
export const sendWhatsAppToAdmin = async (data) => {
	try {
		const response = await axios.post(`${API_URL}/whatsapp/admin`, data);
		return response.data;
	} catch (error) {
		console.error('Error sending WhatsApp to admin:', error);
		throw error;
	}
};

// Send WhatsApp to multiple/all admins (omit adminIds for ALL)
export const sendWhatsAppToAdmins = async (data) => {
	try {
		const response = await axios.post(`${API_URL}/whatsapp/admins`, data);
		return response.data;
	} catch (error) {
		console.error('Error sending WhatsApp to admins:', error);
		throw error;
	}
};

// ════════════════════════════════════════════════════
// ✅ APP PUSH ONLY senders (saves DB + expo push, no whatsapp)
// ════════════════════════════════════════════════════

// Send App notification to a single user
export const sendAppToUser = async (data) => {
	try {
		const response = await axios.post(`${API_URL}/app/user`, data);
		return response.data;
	} catch (error) {
		console.error('Error sending app notification to user:', error);
		throw error;
	}
};

// Send App notification to multiple/all users (omit userIds for ALL)
export const sendAppToUsers = async (data) => {
	try {
		const response = await axios.post(`${API_URL}/app/users`, data);
		return response.data;
	} catch (error) {
		console.error('Error sending app notification to users:', error);
		throw error;
	}
};